export function isValidEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

export function showDateFR(params) {
  const date = new Date(params);
  return params ? date.toLocaleDateString("fr-FR") : "--/--/----";
}

export function formatPhoneNumber(number) {
  if (!number) return "";
  let cleanNumber = number.replace(/\D/g, "");
  const res = cleanNumber.replace(
    /(\d{3})(\d{2})(\d{3})(\d{2})/,
    "$1 $2 $3 $4"
  );
  return res;
}

export function formatCIN(number) {
  if (!number) return "";
  let cleanNumber = number.replace(/\D/g, "");
  const res = cleanNumber.replace(
    /(\d{3})(\d{3})(\d{3})(\d{3})/,
    "$1 $2 $3 $4"
  );
  return res;
}

export function showFullName(lastName, firstName) {
  const lname = lastName ? lastName.toUpperCase() : "";
  const fname = firstName
    ? firstName
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ")
    : "";
  return `${lname} ${fname}`;
}

export function showMoneyFormat(amount, unit) {
  const montant = Number(amount) || 0;
  return `${montant.toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
  })} ${unit}`;
}
export function showNumbreFormat(amount, unit) {
  const montant = Number(amount) || 0;
  return `${montant.toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
  })} ${unit ? (montant > 1 ? unit + "s" : unit) : ""}`;
}

export const handleCopy = async (textToCopy) => {
  try {
    await navigator.clipboard.writeText(textToCopy);
    return true;
  } catch (err) {
    return false;
  }
};

export const enleverBaliseHtml = (texte) => {
  if (!texte) return "";
  return texte.replace(/<\/?[^>]+(>|$)/g, "");
};

export const getBackendUploadFolderLink = (file) => {
  return process.env.REACT_APP_BACKEND_BASE_URL + file;
};

export const getBackendProfilePictureLink = (photo) => {
  return getBackendUploadFolderLink("/uploads/profilepic/" + photo);
};

export const openLink = (link, new_onglet = true) => {
  if (new_onglet) {
    window.open(link, "_blank");
  } else {
    window.open(link);
  }
};

export const isEmailFromDomain = (email, domain) => {
  return email.toLowerCase().endsWith(`@${domain.toLowerCase()}`);
};
